import { combineReducers } from '@reduxjs/toolkit'
import PermissionReducer from './reducer'
const reducer = combineReducers({
  PermissionReducer,
})

export default reducer
